
import { Answer } from "@/interfaces/Answer";
import { Question } from "@/interfaces/Question";
import Vue from "vue";
import SelectItemVueComponentVue from "./SelectItemVueComponent.vue";
import api from "@/webapi";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "question-multiple-free-text",
  props: {
    value: Object,
    showerror: Boolean,
    placeholder: String,
    searchMethod: String,
    readonly: {
      default: false,
      type: Boolean,
    },
    userView: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      question: null as Question | null,
      IDCounter: null as number | null,
      initialLoad: true,
      options: [],
      selectedOption: null as string | null,
      selectedAnswersProc: false,
      timeout: 0,
      city: "",
      state: "",
      zip: "",
      loading: false,
    };
  },
  created() {
    this.importData(this.value);
  },
  computed: {
    selectedAnswerText(): string | null {
      var result = null;
      if (this.question === null) return null;
      var selectedAnswers = this.question.selectedAnswers;
      if (selectedAnswers && selectedAnswers.length > 0 && selectedAnswers[0].answerID !== 999) {
        selectedAnswers[0].answerText = selectedAnswers[0].answerText != null ? selectedAnswers[0].answerText.toUpperCase() : selectedAnswers[0].answerText;
        result = selectedAnswers[0].answerText.split("|")[1] || selectedAnswers[0].answerText;
      }
      return result;
    },
    handleReadonlyExcl() {
      if (this.question === null) return;
      if (!this.readonly) return false;
      if (!this.question.selectedAnswers) return false;
      if (this.userView) return false;
      for (var i = 0; i < this.question.selectedAnswers.length; i++) {
        if (this.question.selectedAnswers[i].deny) {
          return true;
        }
      }
      return false;
    },
    ...mapGetters({
      Lang: "getLang",
    }),
  },
  watch: {
    value(newVal) {
      this.initialLoad = true;
      this.importData(newVal);
    },
    "question.selectedAnswers": {
      handler(val) {
        if (this.selectedAnswersProc) {
          this.selectedAnswersProc = false;
          return;
        }

        var remove = null;
        for (var i = 0; i < val.length; i++) {
          if (val[i].answerText !== null && val[i].answerText.length === 0) {
            remove = i;
          }
        }
        if (remove !== null) {
          this.selectedAnswersProc = true;
          val.splice(remove, 1);
          remove = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    importData(newVal: Question) {
      var selectedAnswers = newVal.selectedAnswers;
      if (newVal.exemptAnswer != null && selectedAnswers != null && selectedAnswers.length == 1 && selectedAnswers[0].answerText == newVal.exemptAnswer.answerText) {
        selectedAnswers[0] = newVal.exemptAnswer;
      }
      this.question = newVal;
      if (!this.question.selectedAnswers || this.question.selectedAnswers.length === 0) {
        this.question.selectedAnswers = [];
      }
    },
    addAnswer(o: any) {
      if (this.question === null) return;
      if (this.readonly) return;
      var a = this.makeAnswer(`${o.key}|${o.value}`);
      this.selectedAnswersProc = true;
      this.question.selectedAnswers.push(a);
    },
    getID(): number {
      if (this.IDCounter === null) {
        this.IDCounter = this.question && this.question.selectedAnswers && this.question.selectedAnswers.length ? this.question.selectedAnswers[this.question.selectedAnswers.length - 1].answerID : 0;
      }
      this.IDCounter++;
      return this.IDCounter;
    },
    makeAnswer(answerText: string): Answer {
      return { answerText: answerText != null ? answerText.toUpperCase() : answerText, followUpQuestionID: 0, order: 0, answerID: this.getID(), calculated: false };
    },
    search() {
      this.loading = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        const data = await api.post(`/api/questions/SearchPharmacy?city=${this.city}&state=${this.state}&zip=${this.zip}`);
        if (data) {
          if (!data) {
            return;
          }
          this.options = data.data;
        } else {
          console.log("data was null");
        }
      }, 250);
      this.loading = false;
    },
    onRemoveAnswer() {
      if (this.question === null) return;
      if (this.readonly) return;
      if (this.question.selectedAnswers.length >= 1) this.question.selectedAnswers.splice(0, this.question.selectedAnswers.length);
    },
    formatPharmacyDisplay(value: string): string {
      if (typeof value !== "string") return value;

      const openParenIndex = value.indexOf(" (");
      if (openParenIndex === -1) return value;

      const name = value.slice(0, openParenIndex);
      const address = value.slice(openParenIndex + 2);

      return `${name}<br><span class="small">(${address}</span>`;
    },
  },
  components: { SelectItemVueComponentVue },
});
